export default (props, vars) =>
  !vars?.['useapplicationoffer2']?.['applicationOffer']?.['is_neutral'];
